import { render, staticRenderFns } from "./addappMg.vue?vue&type=template&id=07a14daa&"
import script from "./addappMg.vue?vue&type=script&lang=js&"
export * from "./addappMg.vue?vue&type=script&lang=js&"
import style0 from "./addappMg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07a14daa')) {
      api.createRecord('07a14daa', component.options)
    } else {
      api.reload('07a14daa', component.options)
    }
    module.hot.accept("./addappMg.vue?vue&type=template&id=07a14daa&", function () {
      api.rerender('07a14daa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/configuration/components/addappMg.vue"
export default component.exports